import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiMissionsService } from '../../../../services/missions/api/api-missions.service';
import { AlertsService } from '../../../../services/alerts.service';
import { MissionUser } from '../../../../models/missions/mission-user.model';

@Component({
  selector: 'app-mission-users-modal',
  templateUrl: './mission-users-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule]
})
export class MissionUsersModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  missionId: number = 0;
  users: MissionUser[] = [];
  totalResults: number = 0;
  readonly resultsPerPage: number = 25;
  private pageNumber: number = 1;

  get page(): number { return this.pageNumber; }
  get totalPages(): number { return Math.ceil(this.totalResults / this.resultsPerPage); }

  getPageNumbers(): (number | null)[] {
    const total = this.totalPages;
    const current = this.pageNumber;
    const visibleSet = new Set<number>();
    for (let i = 1; i <= Math.min(2, total); i++) visibleSet.add(i);
    for (let i = Math.max(total - 1, 1); i <= total; i++) visibleSet.add(i);
    for (let i = Math.max(1, current - 2); i <= Math.min(total, current + 2); i++) visibleSet.add(i);
    const sorted = Array.from(visibleSet).sort((a, b) => a - b);
    const result: (number | null)[] = [];
    for (let i = 0; i < sorted.length; i++) {
      if (i > 0 && sorted[i] - sorted[i - 1] > 1) result.push(null);
      result.push(sorted[i]);
    }
    return result;
  }

  goToPage(page: number): void { this.pageNumber = page; this.refreshUsers(); }
  onClickPaginationPrevious(): void { this.pageNumber--; this.refreshUsers(); }
  onClickPaginationNext(): void { this.pageNumber++; this.refreshUsers(); }

  constructor(private apiMissionsService: ApiMissionsService, private alertsService: AlertsService) {}

  show(missionId: number): void {
    this.missionId = missionId;
    this.pageNumber = 1;
    this.users = [];
    this.totalResults = 0;
    this.isLoading = false;
    this.modal.show();
    this.refreshUsers();
  }

  private refreshUsers(): void {
    this.isLoading = true;
    this.apiMissionsService.getMissionUsers(this.pageNumber, this.resultsPerPage, this.missionId).then(
      response => {
        this.isLoading = false;
        this.users = response.results;
        this.totalResults = response.resultsTotal;
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error loading mission users : ' + error);
      }
    );
  }
}
